import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  signal,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'app-progress-bar',
  imports: [CommonModule],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,

  template: `
    <div
      class="relative h-2 w-full overflow-hidden rounded-full bg-gray-300"
      role="progressbar"
      aria-valuemin="0"
      aria-valuemax="100"
      [attr.aria-valuenow]="MathRound(internal())"
    >
      <div
        class="h-full bg-columbus-blue-600 origin-left will-change-transform
               transition-transform [backface-visibility:hidden] [transform:translateZ(0)]"
        [style.transitionDuration.ms]="durationMs"
        [style.transitionTimingFunction]="easing"
        [style.transform]="'scaleX(' + internal() / 100 + ')'"
      ></div>
    </div>
  `,
  styles: ``,
})
export class ProgressBarComponent implements OnChanges, AfterViewInit {
  /**
   * Target percentage (0..100). Set to 0 to reset. Set to your target to fill.
   */
  @Input() value = 0;

  /** Animation duration in ms */
  @Input() durationMs = 1000;

  /** Easing for the fill animation */
  @Input() easing = 'cubic-bezier(0.22,1,0.36,1)';

  // Internal progress we animate to; always starts at 0 so first paint is empty.
  readonly internal = signal(0);

  MathRound(value: number) {
    return Math.round(value);
  }

  ngAfterViewInit(): void {
    // Kick the first fill after initial 0% has painted, so you *see* the animation.
    requestAnimationFrame(() => {
      requestAnimationFrame(() => this.internal.set(this.clamp(this.value)));
    });
  }

  ngOnChanges(ch: SimpleChanges): void {
    if (ch['value'] && !ch['value'].firstChange) {
      this.internal.set(this.clamp(this.value));
    }
  }

  private clamp(v: number): number {
    return Math.min(100, Math.max(0, v ?? 0));
  }
}
